class UiPopover extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.popover-text');
    this.content = this.querySelector('.popover-content');
    if (!this.trigger || !this.content || this.controller) return;

    this.hovered = false;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.content.id ||= 'popover-' + Math.random().toString(36).slice(2, 11);
    this.trigger.setAttribute('aria-controls', this.content.id);
    this.setOpen(false);

    // A native button supports Enter/Space on every input type, including desktop.
    this.trigger.addEventListener('click', (event) => {
      // A mouse click following hover must not immediately close the revealed content.
      // Keyboard activation (detail === 0) and touch retain their toggle behavior.
      this.setOpen(event.detail > 0 && this.hovered ? true : !this.isOpen);
    }, options);
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') {
        this.hovered = true;
        this.setOpen(true);
      }
    }, options);
    this.addEventListener('pointerleave', () => {
      this.hovered = false;
      if (!this.contains(document.activeElement)) this.setOpen(false);
    }, options);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.setOpen(false);
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        event.stopPropagation();
        this.setOpen(false);
        this.trigger.focus();
      }
    }, options);
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.setOpen(false);
    }, options);
  }

  setOpen(isOpen) {
    this.isOpen = isOpen;
    this.classList.toggle('show-popover', isOpen);
    this.trigger.setAttribute('aria-expanded', String(isOpen));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('ui-popover')) customElements.define('ui-popover', UiPopover);
